// checkbox Button
// disable buttons for sendOffers list
const disableButtons = () => {
    const directOrderButtons = document.querySelectorAll(
        ".direct-order-button",
    );
    const buttonInputs = document.querySelectorAll<HTMLFormElement>(
        '.checkbox-button input[type="checkbox"]',
    );

    if (buttonInputs.length < 1 || directOrderButtons.length < 1) {
        return;
    }

    const atLeastOneChecked = Array.from(buttonInputs).some(
        (input) => input.checked,
    );

    if (atLeastOneChecked) {
        directOrderButtons.forEach((button) => {
            button.classList.add("disable-button");
        });
    } else {
        directOrderButtons.forEach((button) => {
            button.classList.remove("disable-button");
        });
    }
};

// entry
export const checkboxButton = () => {
    const checkboxButtons =
        document.querySelectorAll<HTMLElement>(".checkbox-button");
    if (checkboxButtons.length < 1) {
        return;
    }

    checkboxButtons.forEach((checkboxButton) => {
        if (checkboxButton.getAttribute("data-click-event-added") === "true") {
            return;
        }

        const checkbox = checkboxButton.querySelector<HTMLFormElement>(
            'input[type="checkbox"]',
        );
        const checkedText =
            checkboxButton.querySelector<HTMLFormElement>(".text span.checked");
        const uncheckedText = checkboxButton.querySelector<HTMLFormElement>(
            ".text span.unchecked",
        );

        if (!checkedText || !uncheckedText) {
            return;
        }

        checkedText.style.display = "none";
        uncheckedText.style.display = "flex";

        checkboxButton.addEventListener("click", (event) => {
            event.preventDefault();

            if (checkbox) {
                checkbox.checked = !checkbox.checked;
                checkbox.dispatchEvent(new Event("change"));

                if (checkbox.checked) {
                    checkedText.style.display = "flex";
                    uncheckedText.style.display = "none";
                    checkboxButton.classList.add("checkbox-button-checked");
                } else {
                    checkedText.style.display = "none";
                    uncheckedText.style.display = "flex";
                    checkboxButton.classList.remove("checkbox-button-checked");
                }
            }

            disableButtons();
        });

        checkboxButton.setAttribute("data-click-event-added", "true");
    });
};
